export default __webpack_public_path__ + "5450d3cada4fd0370ab8d885765f5cc3.svg";